
<template>
  <div class="content">

    <div class="row">
      <div class="col-8"></div>
       <div class="col-auto search-col-div">
        <!-- Header Search Input -->
        <a-input-search class="header-search" :class="searchLoading ? 'loading' : ''" placeholder="Search by appName, databaseName, appDescription, UI stack, API stack…"
          @search="onSearch" :loading='searchLoading' v-model="searchQuery">
          <svg slot="prefix" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z"
              fill="#111827" />
          </svg>
        </a-input-search>
        <!-- / Header Search Input -->
      </div>
    </div>

      <div class="col-12">
        <card>
          <template slot="header">
            <div class="row justify-content-between align-items-between mx-3">

              <h5 class="card-title">Applications</h5>
              
              <div>
                  <base-button class="btn btn-primary" @click="modalApplications = true">Add</base-button>
	              <base-button class="btn btn-primary" @click="toggleView">Toggle View</base-button>
              </div>
              
              <modal :show.sync="modalApplications">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Add Application</h5>
                </template>
                <div>
                  <form @submit.prevent>
  <base-input label="NameId" type="text" placeholder="Enter NameId" v-model="applicationToAdd.nameId"></base-input>
  <base-input label="PackageName" type="text" placeholder="Enter PackageName" v-model="applicationToAdd.packageName"></base-input>
  <base-input label="PackagePath" type="text" placeholder="Enter PackagePath" v-model="applicationToAdd.packagePath"></base-input>
  <base-input label="ApplicationTopLong" type="text" placeholder="Enter ApplicationTopLong" v-model="applicationToAdd.applicationTopLong"></base-input>
  <base-input label="ApplicationSidebarLong" type="text" placeholder="Enter ApplicationSidebarLong" v-model="applicationToAdd.applicationSidebarLong"></base-input>
  <base-input label="DatabaseName" type="text" placeholder="Enter DatabaseName" v-model="applicationToAdd.databaseName"></base-input>
  <base-input label="DatabaseType" type="text" placeholder="Enter DatabaseType" v-model="applicationToAdd.databaseType"></base-input>
  <base-input label="ImageFile" type="text" placeholder="Enter ImageFile" v-model="applicationToAdd.imageFile"></base-input>

  <base-input label="OwnerId" type="text" placeholder="Enter OwnerId" v-model="applicationToAdd.ownerId"></base-input>
  <base-input label="PackageName" type="text" placeholder="Enter PackageName" v-model="applicationToAdd.packageName"></base-input>
  <base-input label="ApiToUse" type="text" placeholder="Enter ApiToUse" v-model="applicationToAdd.apiToUse"></base-input>
  <base-input label="UiToUse" type="text" placeholder="Enter UiToUse" v-model="applicationToAdd.uiToUse"></base-input>
  <base-input label="Deploymenturl" type="text" placeholder="Enter Deploymenturl" v-model="applicationToAdd.deploymenturl"></base-input>
  <base-input label="ApplicationId" type="text" placeholder="Enter ApplicationId" v-model="applicationToAdd.applicationId"></base-input>
                  </form>
                </div>
                <template slot="footer">
                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
                </template>
              </modal>
            </div>
          </template>
<div>
          <span class="table-title">Applications</span>
          <span>({{this.totalElements}})</span>
          <span><a-pagination
				      :current="pagination.current"
				      :total="pagination.total"
				      :pageSize="pagination.pageSize"
				      @change="onTableChange"
				      show-size-changer
				      :pageSizeOptions="['5','10', '20', '30', '40']"
				      @showSizeChange="handleSizeChange"
				    /></span>
</div>

          <!-- Conditionally render the view based on the 'isTableView' flag -->
          <div v-if="isTableView">
            <!-- Render the existing Table View -->
            <a-table :columns="columnsBound" :data-source="applications" :row-key="record => record.ApplicationId" :pagination="false"
              :loading="searchLoading" @change="onTableChange" :scroll="{ x: 'max-content' }">

	              <template slot="applicationId" slot-scope="dataIndex">
	              	<router-link  :to="`/application/${dataIndex}`"><a >{{ dataIndex }}</a></router-link>
	              </template>

             <template slot="lastModified" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="createdOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="endedOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="blackOutStartDate" slot-scope="dataIndex">
              	{{ formatDate(dataIndex) }}
              </template>
            </a-table>
          </div>
          <div v-else>
            <!-- Render the Picture View  -->
            <ApplicationPictureView :applications="applications" />
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import ApplicationService from "../services/ApplicationService";
import { ASelect, ASelectOption, AButton, Table, Pagination } from "ant-design-vue";
import ApplicationPictureView from './ApplicationPictureView.vue';


const applicationsColumns = [
  "applicationId",
  "applicationId"
]

export default {
  props: {
    applications: {
      type: Array,
      required: true,
    },
    totalElements: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    Modal,
    BaseButton,
    BaseInput,
    Table,

    Pagination,
    ApplicationPictureView
  },

  data() {
    return {
      modalApplications: false,
        isTableView: true,

      columns: [
        {
          title: 'Application Id',
				dataIndex: 'applicationId',
	          visible: true,
          scopedSlots: { customRender: 'applicationId' },
          sorter: true
          //sorter: (a, b) => a.applicationId - b.applicationId,
          //sorter: (a, b) => a.applicationId.localeCompare(b.applicationId),
        },
        {
          title: 'Name Id',
		dataIndex: 'nameId',
          visible: false,
          scopedSlots: { customRender: 'nameId' },
          sorter: true
          //sorter: (a, b) => a.nameId - b.nameId,
          //sorter: (a, b) => a.nameId.localeCompare(b.nameId),
        },
        {
          title: 'Application Name',
		dataIndex: 'applicationName',
          visible: true,
          scopedSlots: { customRender: 'applicationName' },
          sorter: true
          //sorter: (a, b) => a.applicationName - b.applicationName,
          //sorter: (a, b) => a.applicationName.localeCompare(b.applicationName),
        },
        {
          title: 'Package Name',
		dataIndex: 'packageName',
          visible: true,
          scopedSlots: { customRender: 'packageName' },
          sorter: true
          //sorter: (a, b) => a.packageName - b.packageName,
          //sorter: (a, b) => a.packageName.localeCompare(b.packageName),
        },
        {
          title: 'Package Path',
		dataIndex: 'packagePath',
          visible: false,
          scopedSlots: { customRender: 'packagePath' },
          sorter: true
          //sorter: (a, b) => a.packagePath - b.packagePath,
          //sorter: (a, b) => a.packagePath.localeCompare(b.packagePath),
        },
        {
          title: 'Application Top Long',
		dataIndex: 'applicationTopLong',
          visible: true,
          scopedSlots: { customRender: 'applicationTopLong' },
          sorter: true
          //sorter: (a, b) => a.applicationTopLong - b.applicationTopLong,
          //sorter: (a, b) => a.applicationTopLong.localeCompare(b.applicationTopLong),
        },
        {
          title: 'Application Sidebar Long',
		dataIndex: 'applicationSidebarLong',
          visible: true,
          scopedSlots: { customRender: 'applicationSidebarLong' },
          sorter: true
          //sorter: (a, b) => a.applicationSidebarLong - b.applicationSidebarLong,
          //sorter: (a, b) => a.applicationSidebarLong.localeCompare(b.applicationSidebarLong),
        },
        {
          title: 'Database Name',
		dataIndex: 'databaseName',
          visible: true,
          scopedSlots: { customRender: 'databaseName' },
          sorter: true
          //sorter: (a, b) => a.databaseName - b.databaseName,
          //sorter: (a, b) => a.databaseName.localeCompare(b.databaseName),
        },
        {
          title: 'Database Type',
		dataIndex: 'databaseType',
          visible: true,
          scopedSlots: { customRender: 'databaseType' },
          sorter: true
          //sorter: (a, b) => a.databaseType - b.databaseType,
          //sorter: (a, b) => a.databaseType.localeCompare(b.databaseType),
        },
        {
          title: 'Image File',
		dataIndex: 'imageFile',
          visible: true,
          scopedSlots: { customRender: 'imageFile' },
          sorter: true
          //sorter: (a, b) => a.imageFile - b.imageFile,
          //sorter: (a, b) => a.imageFile.localeCompare(b.imageFile),
        },
        {
          title: 'Owner Id',
		dataIndex: 'ownerId',
          visible: true,
          scopedSlots: { customRender: 'ownerId' },
          sorter: true
          //sorter: (a, b) => a.ownerId - b.ownerId,
          //sorter: (a, b) => a.ownerId.localeCompare(b.ownerId),
        },
        {
          title: 'Api To Use',
		dataIndex: 'apiToUse',
          visible: true,
          scopedSlots: { customRender: 'apiToUse' },
          sorter: true
          //sorter: (a, b) => a.apiToUse - b.apiToUse,
          //sorter: (a, b) => a.apiToUse.localeCompare(b.apiToUse),
        },
        {
          title: 'Ui To Use',
		dataIndex: 'uiToUse',
          visible: true,
          scopedSlots: { customRender: 'uiToUse' },
          sorter: true
          //sorter: (a, b) => a.uiToUse - b.uiToUse,
          //sorter: (a, b) => a.uiToUse.localeCompare(b.uiToUse),
        },
        {
          title: 'Deploymenturl',
		dataIndex: 'deploymenturl',
          visible: true,
          scopedSlots: { customRender: 'deploymenturl' },
          sorter: true
          //sorter: (a, b) => a.deploymenturl - b.deploymenturl,
          //sorter: (a, b) => a.deploymenturl.localeCompare(b.deploymenturl),
        },
      ],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} applications`,
      },

      applications: [],
      applicationToAdd: {},

      applicationsTable: {
        columns: [...applicationsColumns],
        data: [],
      },

      // New properties for sorting and searching
      sortBy: 'applicationId',           // Column to sort by
      sortOrder: 'asc',     // Sort order (asc or desc)
      searchQuery: '',      // Search query
      searchLoading: false, // Initialize searchLoading property


    };
  },

  watch: {
	  searchQuery: {
		handler: "handleSearchQueryChanged", // Call the fetchData method when searchQuery changes
		immediate: true, // Trigger immediately when the component is mounted
      },
	  page(newPage) {
	    this.pagination.current = newPage;
	  },
	  totalElements(newTotal) {
	    this.pagination.total = newTotal;
	  },
	  pageSize(newSize) {
	    this.pagination.pageSize = newSize;
	  },
  },

  methods: {

    handleSearchQueryChanged() {
    	console.log("handleSearchQueryChanged CALLED FROM @search")
    	this.$root.$emit('searchQueryForApplicationsChanged', this.searchQuery);
    },
    onSearch(value) {
      console.log(value);
      this.searchQuery = value; // Update searchQuery when the user types
    },

    async renderApplicationsTable() {
      this.searchLoading = true; // Set searchLoading to true while fetching data
      this.searchLoading = false;

      this.pagination.total = this.totalElements;
      this.pagination.current = this.page;

      let applicationsTableData = [];
      for (let i = 0; i < this.applications.length; i++) {
        applicationsTableData.push({
          id: i,
          applicationId: this.applications[i].applicationId,
          applicationId: this.applications[i].applicationId,
        });

      }
      this.searchLoading = false;
    },

    handleSizeChange(_current, size) {
      const pageSize = Number(size) || this.pagination.pageSize;

      // update state first
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;

      // emit using UPDATED state, not the stale `_current` arg
      const pageZero = this.pagination.current - 1; // 0
      this.$emit('get-all-applications', this.sortBy, this.sortOrder, pageZero, pageSize);
    },

async onTableChange(arg1, arg2, arg3) {
  // 1) TOP <a-pagination> branch: @change(page, pageSize) or @showSizeChange(current, size)
  if (Number.isFinite(arg1)) {
    const page = Number(arg1);
    const size = Number(arg2);

    if (Number.isFinite(page)) this.pagination.current = page;
    if (Number.isFinite(size)) this.pagination.pageSize = size;

  // 2) TABLE branch: @change(paginationObj, filters, sorter)
  } else if (arg3 && typeof arg3 === 'object') {
    const sorter = arg3 || {};
    if (sorter.field) {
      // Normalize sorter.order; if cleared, flip to next sensible state
      const isNewField = sorter.field !== this.sortBy;
      const next =
        sorter.order === 'ascend'  ? 'asc'  :
        sorter.order === 'descend' ? 'desc' :
        isNewField                 ? 'asc'  : (this.sortOrder === 'asc' ? 'desc' : 'asc');

      this.sortBy = sorter.field;
      this.sortOrder = next;
    }

    // Even with :pagination="false", Ant Table still passes a pagination obj sometimes.
    // Only read it if present and sane.
    const p = arg1;
    if (p && typeof p === 'object') {
      if (Number.isFinite(Number(p.current))) this.pagination.current = Number(p.current);
      if (Number.isFinite(Number(p.pageSize))) this.pagination.pageSize = Number(p.pageSize);
    }
  }

  // Emit/fetch using unified state
  const current = Number(this.pagination.current) || 1;
  const size = Number(this.pagination.pageSize) || 50;

  this.$emit('get-all-applications', this.sortBy, this.sortOrder, current - 1, size);
},
	
	initializeColumns() {
        this.columns = this.columns.filter(item => item.visible);
    },

    routingToUserDetail(id) {
      this.$router.push({ name: 'UserDetail', params: { userId: id.toString() }})
    },
    routingToDeploymentServerDetail(id) {
      this.$router.push({ name: 'DeploymentServerDetail', params: { deploymentServerId: id.toString() }})
    },
    routingToApplicationDetail(id) {
      this.$router.push({ name: 'ApplicationDetail', params: { applicationId: id.toString() }})
    },
    
    toggleView() {
      this.isTableView = !this.isTableView;
    },
	
	async handleAddSubmitted() {
      this.modalApplications = false;

      const currentDate = new Date().getTime();
      this.applicationToAdd.created = currentDate;

      const jsonData = JSON.stringify(this.applicationToAdd);
      console.log(jsonData);
      
      const res = await ApplicationService.addApplication(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},
	
	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
	computed: {
	  // feed the table columns with a UI sort state
	  columnsBound() {
	    const uiOrder = this.sortOrder === 'asc' ? 'ascend' : 'descend';
	    return this.columns
	      .filter(c => c.visible)
	      .map(c => ({
	        ...c,
	        key: c.key || c.dataIndex,
	        sorter: c.sorter ?? true,
	        sortDirections: ['ascend', 'descend'],   // no cleared state
	        sortOrder: c.dataIndex === this.sortBy ? uiOrder : null,
	      }));
	  },
	},
  mounted() {
  	this.initializeColumns();
    this.renderApplicationsTable();
  }
};
</script>

<style>
.modal-dialog {
  margin-top: -300px;
}
.ant-table-row  {
	text-align: center;
}
.ant-table-thead th span {
	text-align: center;
	width: 100%
}
.ant-table-fixed td span {
    text-align: center;
}

.table-title {
	font-size: 1.75rem;
	font-weight: bold;
	font-style: italic;
	color: rgb(52, 152, 219); 
	text-align: left;
	padding: 0px 15px;
}

.application-link {
	color: #11ba81;
}

</style>

